<style lang="less" scoped>
    .fee-radio {
        width: 90px;
        text-align: center;
        background-color: #BB87F3;
    }
    .card-review {
        width: 670px;
        height: 450px;
        //background: rgba(255, 255, 255, 1);
        //border-radius: 25px;
        //border: 1px solid;
        margin-left: 27px;
        //text-align: center;
        background-image: url("../../../assets/menu-img/bg.png");
        background-size: 100% 100%;
        padding-left: 50px;
        padding-top: 60px;
    }
    .card-title {    
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131315;
        line-height: 20px;
    }
    .card-money {       
        font-size: 65px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 70px;
        margin-top: 7px;
    }
    .card-code {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #131315;;
        line-height: 20px;
        margin-top: 90px;
    }
    .card-num{     
        font-size: 30px;
        font-family: Helvetica;
        color: #FFFFFF;
        line-height: 20px;
        margin-top: 18px;
    }
    .card-img {
        width: 270px;
        height: 270px;
        background: rgba(255, 255, 255, 1);
        margin-top: 19px;
        margin-left: 192px;
        border: solid 1px;
    }
    .card-use-mes {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(74, 74, 74, 1);
        line-height: 28px;
        margin-top: 50px;
    }
    .card-use-range {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(74, 74, 74, 1);
        line-height: 28px;
        margin-top: 8px;
    }
    .user-mes {
        margin-bottom: 20px;
        .user-mes-div {
            margin: 0px 30px 5px 30px;
        }
    }
    // /deep/.el-input__inner {
    //     background: #F8F9FC;
    //     font-size: 12px;
    //     font-weight: 400;
    //     color: #BCBCBC;
    //     line-height: 17px;       
    //     font-family: PingFangSC-Regular, PingFang SC;      
    //     border-radius: 4px;
    // }
    .serve-btn,.copy-btn{
        width: 128px;
        height: 40px;
        border-radius: 4px;
        box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.09);
        line-height: 20px;
        cursor: pointer;
        border: 1px solid #BB87F3;    
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
    }
    .serve-btn{
        color: #BB87F3;       
        background: #FFFFFF;
        
    }
    .copy-btn{
        color: #ffffff;       
        background: #BB87F3;
        margin-left: 15px;
    }
    .logo-div{
        width: 49px;
        height: 43px;
    }
    .code-title-div{      
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
    }
    .code-div{
        width: 60px;
        height: 60px;
        margin-top: 4px;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">制卡管理</div>
            <ZD-list-querys>
                <template slot="inputs">
                            <div class="list-query-child-div flex">
                                <div class="query-title-div">制卡人</div>
                                <div class="query-inputs-div flex-1">
                                    <el-input size="small" v-model="queryInfo.madeBy" placeholder="请输制卡人" @keyup.enter.native="getListData(pagination,true)"></el-input>
                                </div>
                            </div>
                            <div class="list-query-child-div flex">
                                <div class="query-title-div">使用人账号</div>
                                <div class="query-inputs-div flex-1">
                                    <el-input size="small" v-model="queryInfo.useredBy" placeholder="请输入手机号" @keyup.enter.native="getListData(pagination,true)"></el-input>
                                </div>
                            </div>
                            <div class="list-query-child-div flex">
                                <div class="query-title-div">使用状态</div>
                                <div class="query-inputs-div flex-1">
                                    <el-select class="full-width" size="small" v-model="queryInfo.cardStatus" clearable >
                                        <el-option label="未兑换" value="01"></el-option>
                                        <el-option label="已兑换" value="02"></el-option>
                                    </el-select>
                                </div>
                            </div>
                </template>
                <template slot="actions">
                    <button class="common-bg-button" @click="getListData(pagination, true) ">搜 索</button>
                    <button class="common-empty-button" @click="reset()">重 置</button>
                </template>
            </ZD-list-querys>
            
            <div class="page-action-btns flex">
                <button class="common-bg-button" @click="madeCard()">制作充电卡</button>
                <!-- <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.dealerName" placeholder="请输入运营商名称" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button> -->
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
            <el-dialog title="制作充电卡" :visible.sync="dialogFormVisible" width="44%" @close="handleDialogFormClose('form')">
                <el-form :model="form" ref="form" :rules="pageConfig.formRules" >
                    <el-form-item label-width="20px" prop="cardMoney">
                        <div>选择制卡度电</div>
                        <div>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="10" border size="medium">10</el-radio>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="50" border size="medium">50</el-radio>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="100" border size="medium">100</el-radio>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="200" border size="medium">200</el-radio>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="500" border size="medium">500</el-radio>
                            <el-radio class="fee-radio" v-model="form.cardMoney" label="1000" border size="medium">1000</el-radio>
                        </div>
                    </el-form-item>
                    <el-form-item prop="madeReason" label-width="20px">
                        <el-input style="width:720px;" size="small" type="textarea" :rows="7" placeholder="请输入制卡原因，备注" v-model="form.madeReason"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <button class="serve-btn" @click="dialogFormVisible = false" size="small">取消</button>
                    <button class="copy-btn" @click="handleMadeCard('form')">确定</button>
                    <!-- <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="handleMadeCard('form')" size="small">确 定</el-button> -->
                </div>
            </el-dialog>
            <el-dialog :title="cardDialogTitle" :visible.sync="dialogVisible" width="759px">
                <!-- <div class="user-mes" v-if="userMesFlag">
                    <div class="flex">
                        <div class="user-mes-div">制卡人：{{cardObj.madeBy}}</div>
                        <div class="user-mes-div">制卡时间：{{cardObj.madeTime}}</div>
                        <div class="user-mes-div">使用状态：{{cardObj.cardStatusName}}</div>
                    </div>
                    <div class="flex">
                        <div class="user-mes-div">使用时间：{{cardObj.useredTime}}</div>
                        <div class="user-mes-div">使用账号：{{cardObj.useredBy}}</div>
                    </div>
                </div> -->
                <div class="card-review flex" ref="imageDom">
                    <div style="width: 537px">
                        <div class="card-title">桩到家度电卡</div>
                        <div class="card-money">{{cardObj.cardMoney}}<span class="unit">度</span></div>
                        <div class="card-code">兑换码</div>
                        <div class="card-num">{{cardObj.changeCode}}</div>
                        <!-- <div class="card-img">1</div> -->
                        <div class="card-use-mes">使用方法:打开桩到家APP-个人中心-充电卡兑换</div>
                        <div class="card-use-range">使用范围:挚达科技运营所有电桩，详见APP充电卡</div>
                    </div>
                    <div>
                        <img class="logo-div" src="../../../assets/menu-img/logo.png">
                        <div style="margin-top: 245px;">
                            <div class="code-title-div">App下载</div>
                            <img class="code-div" src="../../../assets/menu-img/code.png">
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <button class="serve-btn" @click="clickGeneratePicture">保存为图片</button>
                    <button class="copy-btn" @click="copycert">复制到剪贴板</button>
                </div>
            </el-dialog>
            
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    import html2canvas from "html2canvas";
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},
                form: {},
                userInfo: {},
                operates: {
                    width: 150,
                    fixed: "right",
                    list: [{
                        id: "review",
                        label: "详情",
                        type: "primary",
                        show: true,
                        disabled: false,
                        method: (index, row) => {
                            this.cardObj = row;
                            this.cardObj.changeCode =  this.cardObj.exchangeCode.replace(/(.{4})/g, "$1 ")
                            this.cardDialogTitle = "充电卡详情";
                            this.userMesFlag = true;
                            this.dialogVisible = true;
                        }
                    }, ]
                }, // 列操作按钮
                dialogFormVisible: false,
                dialogVisible: false,
                userMesFlag: false,
                cardDialogTitle: '',
                cardObj: {},
                imgUrl: '',
            }
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo;
                this.getListData(this.pagination,true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                // _.queryInfo.dealerNo = 'DEAL1543895439624'//_.userInfo.dealNo;
                _.$H.get(_, _.$A.finance.chargeCard, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            madeCard() {
                let _ = this;
                _.dialogFormVisible = true;
            },
            handleDialogFormClose(formName) {
                this.form = {};
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
            },
            handleMadeCard(formName) {
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$U.showLoading(_);
                        _.form.corpNo = _.$store.state.corpNo;
                        _.form.createdByName = _.userInfo.createdByName;
                        _.form.dealerName = _.userInfo.dealName;
                        _.form.madeBy = _.userInfo.userName;
                        _.$H.post(_, _.$A.finance.addCard, _.form).then(res => {
                            _.cardObj = res.data.data;
                            _.cardObj.changeCode =  _.cardObj.exchangeCode.replace(/(.{4})/g, "$1 ")
                            _.dialogFormVisible = false;
                            _.cardDialogTitle = "充电卡预览";
                            _.userMesFlag = false;
                            setTimeout(function() {
                                _.dialogVisible = true;
                            }, 400)
                            _.$U.hideLoading(_);
                            _.init();
                        })
                    }
                })
            },
            /**
             * 将页面指定节点内容转为图片 
             * 1.拿到想要转换为图片的内容节点DOM;   
             * 2.转换，拿到转换后的canvas    
             * 3.转换为图片
             */
            clickGeneratePicture() { //生成图片
                html2canvas(this.$refs.imageDom).then(canvas => {
                    // 转成图片，生成图片地址
                    this.imgUrl = canvas.toDataURL("image/jpeg");
                    //this.imgUrl = canvas.toDataURL("image/png"); //可将 canvas 转为 base64 格式
                    var eleLink = document.createElement("a");
                    eleLink.href = this.imgUrl; // 转换后的图片地址
                    eleLink.download = "充电卡";
                    document.body.appendChild(eleLink);
                    // 触发点击
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                });
            },
            selectText(element) {
                var doc = document;
                if (doc.body.createTextRange) {
                    var range = document.body.createTextRange();
                    range.moveToElementText(element);
                    range.select();
                } else if (window.getSelection) {
                    var selection = window.getSelection();
                    var range = document.createRange();
                    range.selectNodeContents(element);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    console.log(selection);
                }
            },
            copycert() {
                let _ = this;
                $(".card-review").attr("contenteditable", true);
                _.selectText($(".card-review").get(0)); //取第一位 this调用了实例上的东西
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
                $(".card-review").removeAttr("contenteditable");
                alert("image copied!");
            },
            reset() {
                let _ = this;
                this.pagination.current = 1;
                delete _.queryInfo.madeBy;
                delete _.queryInfo.useredBy;
                delete _.queryInfo.cardStatus;
                _.init();
            }
        },
        mounted() {
            this.init();
        }
    }
</script>